  import React, { useState } from 'react';
  import { Card, Tabs } from 'antd';
  import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

  import Dashboard from './components/Dashboard';
  import MedicationTable from './components/MedicationTable';
  // import PrescriptionsList from './components/PrescriptionsList';
  import OrdersTable from './components/OrdersTable';
  import Reports from './components/Reports';
  import NewPrescriptionForm from './pages/NewPrescriptionForm';
  import AddMedicationForm from './components/AddMedicationForm';
  import AddOrderForm from './pages/AddOrderForm';
  import InventoryReport from './pages/Reports/InventoryReport';
  import PrescriptionAnalytics from './pages/Reports/PrescriptionAnalytics';
  import FinancialSummary from './pages/Reports/FinancialSummary';


  import {
    medications,
    // prescriptions,
    orders,

  } from './data/sampleData';

  const { TabPane } = Tabs;

  function MainTabs({ defaultTab = '1' }) {
    const [activeTab, setActiveTab] = useState(defaultTab);

    return (
      <div style={{ padding: '24px' }}>
        <Dashboard />
        <Card bordered={false} style={{ borderRadius: '8px' }}>
          <Tabs activeKey={activeTab} onChange={setActiveTab}>
            <TabPane tab="Inventory" key="1">
              <MedicationTable medications={medications} />
            </TabPane>
            {/* <TabPane tab="Prescriptions" key="2">
              <PrescriptionsList prescriptions={prescriptions} />
            </TabPane> */}
            <TabPane tab="Orders" key="3">
              <OrdersTable orders={orders} />
            </TabPane>
            <TabPane tab="Reports" key="4">
              <Reports />
            </TabPane>
          </Tabs>
        </Card>
      </div>
    );
  }


  function App() {
    return (
      <Router>
        <Routes>
          <Route path="/" element={<MainTabs />} />
          <Route path="/prescriptions/new" element={<NewPrescriptionForm />} />
          {/* <Route path="/" element={<MedicationTable medications={medications} />} /> */}
          <Route path="/" element={<MainTabs />} />
          <Route path="/add-medication" element={<AddMedicationForm />} />
          <Route path="/orders/new" element={<AddOrderForm />} />
          <Route path="/reports/inventory" element={<InventoryReport />} />
          <Route path="/reports/analytics" element={<PrescriptionAnalytics />} />
          <Route path="/reports/financial" element={<FinancialSummary />} />
          <Route path="/dashboard/reports" element={<Reports />} />
          <Route path="/inventory" element={<MainTabs defaultTab="1" />} />
          <Route path="/prescriptions" element={<MainTabs defaultTab="2" />} />
          <Route path="/orders" element={<MainTabs defaultTab="3" />} />
          <Route path="/reports" element={<MainTabs defaultTab="4" />} />
          </Routes>
      </Router>
    );
  }

  export default App;











//   {
//   "name": "pharmacy",
//   "version": "0.1.0",
//   "private": true,
//   "dependencies": {
//     "@ant-design/icons": "^5.6.1",
//     "@testing-library/jest-dom": "^5.17.0",
//     "@testing-library/react": "^13.4.0",
//     "@testing-library/user-event": "^14.4.3",
//     "antd": "^5.24.9",
//     "axios": "^1.10.0",
//     "dayjs": "^1.11.13",
//     "moment": "^2.30.1",
//     "react": "^18.2.0",
//     "react-dom": "^18.2.0",
//     "react-router-dom": "^7.6.2",
//     "xlsx": "^0.18.5"
//   },
  
//   "scripts": {
//     "start": "cross-env PORT=4002 react-scripts start",
//     "build": "BUILD_PATH=dist react-scripts build",
//     "test": "react-scripts test",
//     "eject": "react-scripts eject"
//   },
//   "eslintConfig": {
//     "extends": [
//       "react-app",
//       "react-app/jest"
//     ]
//   },
//   "browserslist": {
//     "production": [
//       ">0.2%",
//       "not dead",
//       "not op_mini all"
//     ],
//     "development": [
//       "last 1 chrome version",
//       "last 1 firefox version",
//       "last 1 safari version"
//     ]
//   },
//   "devDependencies": {
//     "cross-env": "^7.0.3",
//     "react-scripts": "^5.0.1"
//   }
// }







